import React, { act } from "react";
import classes from "./TitleHeader.module.css";
import { useNavigate } from "react-router-dom";

const TitleHeader = ({ title, data,mainData , active,activateHandler,hideFilter}) => {
  // return <h1 className={classes.heading}>{title}</h1>;
  console.log(mainData,'maindata---');
  const navigate=useNavigate();

  return <div className={classes.title_container}>
    <div className={classes.title_sub_container}>
      <p className={classes.title}>{title}</p>
      {hideFilter ? null : (
      <button className={classes.switch} type="button" >
        {data?.map((dataItem, i) => {
          return (
            <>
              <div
                className={`${classes.switch_card} ${dataItem?.sub_category_id==active && classes.active
                  }`}
                  key={i}
                  onClick={()=>activateHandler(dataItem?.sub_category_id)}
              >
                <p>{dataItem?.sub_category_name}</p>
              </div>
            </>
          )
        })}

      </button>
      )}
    </div>
    {hideFilter ? null :
    <button type="button" className={classes.view}
    onClick={()=>navigate(`/category/content/${mainData?.main_category_name}?main_category_id=${mainData?.main_category_id}&sub_category_id=${active}`)
  }
    >
      <i className={`pi pi-chevron-right ${classes.icon}`} />
    </button>
    }
  </div>
};

export default TitleHeader;